import { gql } from '@apollo/client';

export const QUERY_ONBOARDING_STEP3 = gql`
  query onBoardingStep3 {
    step3 {
      data {
        attributes {
          content {
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
            button {
              text
              link
            }
          }
        }
      }
    }
  }
`;

export const MUTATION_ONBOARDING_UPDATE_USER = gql`
  mutation updateUserProfile($userId: ID!, $profile: String, $gender: String, $location: String, $ageBracket: String) {
    updateUsersPermissionsUser(
      id: $userId
      data: { profile: $profile, gender: $gender, location: $location, ageBracket: $ageBracket }
    ) {
      data {
        attributes {
          updatedAt
        }
      }
    }
  }
`;
